var a={star:"rl2_staranimation-module_star_26-c6",animate:"rl2_staranimation-module_animate_UzLyv",bigStar:"rl2_staranimation-module_bigStar_Vn4Uf"};export{a as default};
